import broadcast from "../../app/broadcast";

/**
 * Controlador para la ventana de observaciones (ObsWindowController).
 * Gestiona la interacción entre la vista de la ventana de observaciones y los eventos relacionados.
 */
class ObsWindowController {

    /**
     * Constructor de la clase ObsWindowController.
     * Inicializa el controlador y registra el evento para manejar los detalles de observaciones.
     *
     * @param {Object} view - La vista asociada a la ventana de observaciones.
     */
    constructor(view) {
        this.view = view;

        // Registra un evento para abrir los detalles de observaciones.
        broadcast.on("obsDetail", this.openObsDetail.bind(this));
    }

    /**
     * Abre los detalles de una observación.
     * Actualiza la vista con los datos de la observación proporcionados.
     *
     * @param {Object} obsData - Los datos de la observación a mostrar.
     */
    openObsDetail(obsData) {
        this.view.update(obsData);
    }
}

export default ObsWindowController;
